module.exports = __webpack_public_path__ + "img/cover.5ed69192.jpg";